// removed by extract-text-webpack-plugin
module.exports = {"default-logo":"DefaultLogo-module__default-logo___3Nn3G","light":"DefaultLogo-module__light___2luPm"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/Logo/DefaultLogo.module.scss
// module id = 175
// module chunks = 0 1